import Vue from 'vue'
import Router from 'vue-router'
import OutInvoice from '../views/OutInvoice.vue'
import Home from '../views/Home.vue'
import Order from './order'
import User from './user'
import Meeting from './meeting'
import Committee from './committee'

Vue.use(Router)

export default new Router({
  routes: [
    Order,
    User,
    Meeting,
    Committee,
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { title: '中国妇幼保健协会会议广场' },
    },
    {
      path: '/out-invoice',
      name: 'out-invoice',
      component: OutInvoice,
      meta: { title: '中国妇幼保健年底大会发票开取' },
    },
  ]
})
